import domHelper from '../base/DomHelper';
import GridHeaderCell from './GridHeaderCell';
import GridFilterRow from './GridFilterRow';
import Resizable from '../resizable/Resizable';

export const GRID_HEADER_TEMPLATE = `
    <div class="datagrid-header f-row f-noshrink">
        <div ref="headerRef" class="datagrid-header-inner f-full" :style="{height:heightState+'px'}">
            <table ref="contentRef" class="datagrid-htable" border="0" cellspacing="0" cellpadding="0">
				<colgroup>
					<col v-for="col in columns" :style="{width:col.widthState}">
                </colgroup>
                <tbody v-if="columnGroup">
                    <GridFilterRow v-if="filterOnTop" :columns="columns" :grid="grid"></GridFilterRow>
                    <tr v-for="row in columnGroup.rows" class="datagrid-header-row">
                        <td v-for="col in row.columns"
                                v-Resizable="getResizableOpts(col)"
                                :rowspan="col.rowspan"
                                :colspan="col.colspan"
                                :class="{'datagrid-field-td':col.field,'datagrid-header-over':hoverColumn==col && col.sortable}"
                                @mouseenter="hoverColumn=col"
                                @mouseleave="hoverColumn=null"
                                @click="onCellClick($event,col)">
                            <GridHeaderCell :column="col"></GridHeaderCell>
                        </td>
                    </tr>
                    <GridFilterRow v-if="filterOnBottom" :columns="columns" :grid="grid"></GridFilterRow>
                </tbody>
                <tbody v-if="!columnGroup">
                    <GridFilterRow v-if="filterOnTop" :columns="columns" :grid="grid"></GridFilterRow>
                    <tr class="datagrid-header-row">
                        <td v-for="col in columns"
                                v-Resizable="getResizableOpts(col)"
                                v-Draggable="getDraggableOpts(col)"
                                v-Droppable="getDroppableOpts(col)"
                                class="datagrid-field-td"
                                :class="{'datagrid-header-over':hoverColumn==col && col.sortable}"
                                @mouseenter="hoverColumn=col"
                                @mouseleave="hoverColumn=null"
                                @click="onCellClick($event,col)">
                            <GridHeaderCell :column="col"></GridHeaderCell>
                        </td>
                    </tr>
                    <GridFilterRow v-if="filterOnBottom" :columns="columns" :grid="grid"></GridFilterRow>
                </tbody>
            </table>
        </div>
		<div v-if="paddingWidth" class="datagrid-header f-noshrink" :style="{width:paddingWidth+'px'}"></div>
        <DraggableProxy ref="proxy">
            <div class="datagrid-moving-proxy">{{dragScope.column?dragScope.column.title:null}}</div>
        </DraggableProxy>
    </div>
`;

export default {
    name: 'GridHeader',
    template: GRID_HEADER_TEMPLATE,
    components: {
        GridHeaderCell,
        GridFilterRow
    },
    directives: {
        Resizable
    },
    props: {
        columns: {
            type: Array,
            default: () => []
        },
        columnGroup: Object,
        paddingWidth: {
            type: Number,
            default: 0
        },
        filterable: {
            type: Boolean,
            default: false
        },
        grid: Object
    },
    data() {
        return {
            heightState: 0,
            scrollLeftState: 0,
            hoverColumn: null,
            dragScope: {}
        }
    },
    computed: {
        filterOnTop() {
            if (this.grid.filterable) {
                if (this.grid.filterPosition == 'both' || this.grid.filterPosition == 'top') {
                    return true;
                }
            }
            return false;
        },
        filterOnBottom() {
            if (this.grid.filterable) {
                if (this.grid.filterPosition == 'both' || this.grid.filterPosition == 'bottom') {
                    return true;
                }
            }
            return false;
        }
    },
    methods: {
        height(value) {
            if (value == undefined) {
                return domHelper.outerHeight(this.$refs.contentRef);
            } else {
                this.heightState = value ? value - 1 : value;
            }
        },
        scrollLeft(value) {
            if (value == undefined) {
                return this.scrollLeftState;
            } else {
                this.scrollLeftState = value;
                this.$refs.headerRef.scrollLeft = value;
            }
        },
        onCellClick(event, col) {
            this.$emit('cellClick', {
                column: col,
                originalEvent: event
            });
        },
        getResizableOpts(col) {
            return {
                disabled: !this.grid.columnResizing || !col.field,
                handles: 'e',
                resizing: (event) => { this.onColumnResizing(col, event) },
                resizeStop: (event) => { this.onColumnResizeStop(col, event) }
            }
        },
        getDraggableOpts(col) {
            return {
                disabled: !this.grid.columnMoving || !col.field,
                revert: true,
                deltaX: 0,
                deltaY: 0,
                edge: 5,
                scope: this.dragScope,
                proxy: this.$refs.proxy,
                dragStart: (event) => { this.onColumnDragStart(col, event) }
            }
        },
        getDroppableOpts(col) {
            return {
                field: col.field,
                dragOver: (scope) => { this.onColumnDragOver(col, scope) },
                dragLeave: (scope) => { this.onColumnDragLeave(col, scope) },
                drop: (scope) => { this.onColumnDrop(col, scope) }
            }
        },
        onColumnResizing(col, event) {
            event.target.style.width = null;
            event.target.style.left = null;
            event.target.style.top = null;
            this.grid.resizeColumn(col.field, event.width);
        },
        onColumnResizeStop(col, event) {
            event.target.style.width = null;
            event.target.style.left = null;
            event.target.style.top = null;
            this.grid.resizeColumn(col.field, event.width);
        },
        onColumnDragStart(col, event) {
            Object.assign(this.dragScope, {
                column: col,
                event: event,
                fromIndex: this.grid.allColumns.indexOf(col),
                viewOffset: domHelper.offset(this.grid.$refs.viewRef)
            })
        },
        onColumnDragOver(col, scope) {
            if (!scope) {
                return;
            }
            scope.toIndex = this.grid.allColumns.indexOf(col);
            const diff = scope.fromIndex - scope.toIndex;
            scope.point = diff === 0 ? null : (diff < 0 ? 'after' : 'before');
            let splitStyle = null;
            if (diff !== 0) {
                let el = scope.event.target.currDroppable.$el;
                let offset = domHelper.offset(el);
                let left = offset.left - scope.viewOffset.left;
                if (scope.toIndex !== 0) {
                    left -= 1;
                }
                splitStyle = {
                    left: domHelper.toStyleValue(diff < 0 ? left + domHelper.outerWidth(el) : left),
                    top: 0
                };
            }
            this.grid.splitStyle = splitStyle
        },
        onColumnDragLeave() {
            this.grid.splitStyle = null;
        },
        onColumnDrop(col, scope) {
            if (!scope) {
                return;
            }
            this.dragScope = {};
            this.$nextTick(() => {
                if (scope.point) {
                    this.grid.moveColumn(scope.column.field, col.field, scope.point)
                }
            })
        }
    }
}